// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.personalized-service-page {
    background: #ffffff;
}

.personalized-service-section {
    padding-top: 44px;
    padding-bottom: 12px;
}

.personalized-service-page .personalized-service-section:last-of-type {
    padding-bottom: 44px;
}

.personalized-service-hero {
    position: relative;
    overflow: hidden;
    min-height: 60vh;
    display: flex;
    align-items: center;
    background:
        linear-gradient(135deg, rgba(10, 10, 12, 0.96), rgba(30, 12, 14, 0.92)),
        #0d0d10;
    color: #ffffff;
}

.personalized-service-hero-bg {
    position: absolute;
    inset: 0;
}

.personalized-service-grid {
    position: absolute;
    inset: -24%;
    background-image:
        linear-gradient(to right, rgba(217, 0, 27, 0.12) 1px, transparent 1px),
        linear-gradient(to bottom, rgba(217, 0, 27, 0.08) 1px, transparent 1px);
    background-size: 44px 44px;
    transform: perspective(720px) rotateX(64deg);
    animation: personalizedServiceGridMove 24s linear infinite;
}

.personalized-service-glow {
    position: absolute;
    inset: 0;
    background:
        radial-gradient(circle at 18% 24%, rgba(217, 0, 27, 0.2), transparent 24%),
        radial-gradient(circle at 82% 72%, rgba(255, 214, 214, 0.08), transparent 22%);
}

.personalized-service-hero-content {
    position: relative;
    z-index: 1;
    display: grid;
    grid-template-columns: minmax(0, 1.1fr) minmax(280px, 0.7fr);
    gap: 28px;
    align-items: center;
    padding-top: 128px;
    padding-bottom: 76px;
}

.personalized-service-hero-copy {
    max-width: 760px;
}

.personalized-service-kicker {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 0.78rem;
    font-weight: 700;
    letter-spacing: 0.12em;
    text-transform: uppercase;
    color: var(--accent-red);
}

.personalized-service-hero-title {
    margin: 18px 0 14px;
    font-size: clamp(2.5rem, 5vw, 4.6rem);
    line-height: 1.04;
}

.personalized-service-hero-description {
    max-width: 720px;
    color: rgba(255, 255, 255, 0.84);
    font-size: 1.02rem;
    line-height: 1.82;
}

.personalized-service-hero-visual {
    display: block;
    justify-self: end;
    width: min(100%, 360px);
    min-width: 320px;
    position: relative;
    z-index: 1;
}

.personalized-service-block,
.personalized-service-strengths {
    background: rgba(255, 255, 255, 0.98);
    border: 1px solid rgba(217, 0, 27, 0.08);
    border-radius: 24px;
    box-shadow: 0 14px 32px rgba(22, 22, 26, 0.05);
    padding: 24px;
}

.personalized-service-block + .personalized-service-block {
    margin-top: 16px;
}

.personalized-service-subsection-head {
    margin-bottom: 16px;
    display: block;
    align-items: center;
}

.personalized-service-subsection-head h3 {
    margin: 0;
    font-size: 1.6rem;
    line-height: 1.15;
    color: #343434;
}

.personalized-service-split-layout {
    display: grid;
    grid-template-columns: minmax(0, 1fr) 220px;
    gap: 18px;
    align-items: stretch;
    grid-auto-rows: 1fr;
}

.personalized-service-split-layout-compact {
    grid-template-columns: minmax(0, 0.94fr) 380px;
}

.personalized-service-split-layout-compact:not(.is-text-only) {
    min-height: 340px;
}

.personalized-service-split-layout.is-text-only {
    grid-template-columns: 1fr;
}

.personalized-service-process-grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 14px;
}

.personalized-service-process-card,
.personalized-service-advantage-card,
.personalized-service-point-card,
.personalized-service-strength-card,
.personalized-service-case-card {
    border-radius: 18px;
    border: 1px solid rgba(217, 0, 27, 0.1);
    background: linear-gradient(180deg, #ffffff 0%, #fdf8f7 100%);
}

.personalized-service-process-card,
.personalized-service-point-card,
.personalized-service-strength-card {
    padding: 18px;
}

.personalized-service-process-card.is-wide {
    grid-column: 1 / -1;
}

.personalized-service-process-card h4,
.personalized-service-advantage-card h4,
.personalized-service-point-card h4,
.personalized-service-strength-card h3 {
    margin-bottom: 6px;
    color: var(--text-main);
    line-height: 1.5;
}

.personalized-service-process-card p,
.personalized-service-advantage-card p,
.personalized-service-point-card p,
.personalized-service-paragraph-stack p,
.personalized-service-strength-card p,
.personalized-service-strength-intro,
.personalized-service-lead {
    color: var(--text-light);
    line-height: 1.82;
}

.personalized-service-advantage-grid,
.personalized-service-strength-grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 14px;
}

.personalized-service-advantage-card {
    padding: 18px;
}

.personalized-service-case-grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 14px;
}

.personalized-service-case-grid.is-single {
    grid-template-columns: minmax(0, 420px);
}

.personalized-service-case-card {
    display: flex;
    flex-direction: column;
    gap: 12px;
    padding: 14px;
    flex: 1 1 auto;
    height: 100%;
    min-width: 0;
}

.personalized-service-case-image {
    overflow: hidden;
    border-radius: 14px;
    display: flex;
    align-items: stretch;
    flex: 1 1 0;
    min-height: 0;
    height: 100%;
    background: #f4f4f4;
}

.personalized-service-case-placeholder {
    width: 100%;
    height: 100%;
    min-height: 0;
    border-radius: 14px;
    background: #d9d9d9;
}

.personalized-service-case-copy {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 14px;
    color: var(--text-main);
    font-weight: 700;
    line-height: 1.7;
}

.personalized-service-case-arrow {
    color: var(--accent-red);
    font-size: 1.2rem;
    flex-shrink: 0;
}

.personalized-service-custom-stack {
    display: grid;
    gap: 16px;
}

.personalized-service-item-case {
    margin-top: 18px;
}

.personalized-service-content-column {
    display: flex;
    flex-direction: column;
    justify-content: stretch;
    height: 100%;
    min-height: 0;
}

.personalized-service-content-column.is-story {
    gap: 14px;
}

.personalized-service-case-section-title {
    margin-bottom: 14px;
    color: var(--accent-red);
    font-size: 0.9rem;
    font-weight: 700;
    letter-spacing: 0.08em;
    text-transform: uppercase;
}

.personalized-service-case-panel {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: stretch;
    flex: 1 1 auto;
    padding: 18px;
    border-radius: 18px;
    border: 1px solid rgba(217, 0, 27, 0.1);
    background: linear-gradient(180deg, #ffffff 0%, #fdf8f7 100%);
    min-height: 0;
}

.personalized-service-case-grid-side {
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: minmax(0, 1fr);
    flex: 1 1 auto;
    height: 100%;
    min-height: 0;
}

.personalized-service-case-grid-side.is-single {
    grid-template-columns: 1fr;
}

.personalized-service-lead {
    margin-bottom: 12px;
    font-size: 0.98rem;
    font-weight: 700;
    color: var(--text-main);
}

.personalized-service-story-intro,
.personalized-service-story-card {
    border-radius: 18px;
    border: 1px solid rgba(217, 0, 27, 0.1);
    background: linear-gradient(180deg, #ffffff 0%, #fdf8f7 100%);
    padding: 18px;
}

.personalized-service-story-intro .personalized-service-lead {
    margin-bottom: 0;
    font-size: 1rem;
    line-height: 1.78;
}

.personalized-service-point-grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 14px;
    height: 100%;
    align-content: stretch;
}

.personalized-service-point-grid > .personalized-service-point-card {
    height: 100%;
}

.personalized-service-paragraph-stack {
    display: grid;
    gap: 10px;
}

.personalized-service-paragraph-stack.is-story-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 14px;
    flex: 1 1 auto;
}

.personalized-service-story-card {
    display: flex;
    align-items: flex-start;
    min-height: 100%;
}

.personalized-service-story-card p {
    margin: 0;
}

.personalized-service-strengths {
    display: grid;
    gap: 18px;
}

.personalized-service-strength-intro {
    max-width: 900px;
    font-size: 0.98rem;
}

.personalized-service-side-visual {
    width: 100%;
    height: 100%;
    display: flex;
    align-self: stretch;
    min-height: 0;
}

.personalized-service-side-visual-case {
    height: 100%;
    min-height: 0;
}

.personalized-service-side-visual-case .personalized-service-case-card {
    padding: 0;
    border: none;
    background: transparent;
    min-height: 0;
}

.personalized-service-side-visual-case .personalized-service-case-copy {
    padding-top: 4px;
}

.personalized-service-side-visual-case .personalized-service-case-image {
    min-height: 240px;
}

.personalized-service-visual-image {
    width: 100%;
    height: 100%;
    display: block;
    object-fit: cover;
    object-position: center;
    border-radius: 18px;
}

.personalized-service-visual-image-tall {
    min-height: 100%;
}

.personalized-service-visual-image-case {
    min-height: 0;
    border-radius: 14px;
}

.personalized-service-case-copy span:first-child,
.personalized-service-case-section-title {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.personalized-service-case-copy span:first-child {
    flex: 1 1 auto;
    min-width: 0;
    font-size: clamp(0.86rem, 0.74rem + 0.25vw, 0.98rem);
}

.personalized-service-placeholder {
    width: 100%;
    height: 100%;
    display: block;
    background: #d1d5db;
    border-radius: 18px;
}

.personalized-service-placeholder-hero {
    min-height: 260px;
    border: 1px solid rgba(255, 255, 255, 0.14);
    background: #d1d5db;
    box-shadow: 0 18px 40px rgba(0, 0, 0, 0.18);
}

.personalized-service-placeholder-tall {
    min-height: 100%;
}

.personalized-service-placeholder-case {
    min-height: 160px;
}

.personalized-service-placeholder-square {
    aspect-ratio: 1 / 1;
}

.personalized-service-placeholder-wide {
    min-height: 160px;
}

@keyframes personalizedServiceGridMove {
    from {
        transform: perspective(720px) rotateX(64deg) translateY(0);
    }

    to {
        transform: perspective(720px) rotateX(64deg) translateY(44px);
    }
}

@media (max-width: 992px) {
    .personalized-service-hero-content,
    .personalized-service-split-layout,
    .personalized-service-split-layout-compact,
    .personalized-service-process-grid,
    .personalized-service-advantage-grid,
    .personalized-service-case-grid,
    .personalized-service-point-grid,
    .personalized-service-strength-grid {
        grid-template-columns: 1fr;
    }

    .personalized-service-hero-visual,
    .personalized-service-side-visual {
        width: 100%;
        min-width: 0;
        justify-self: stretch;
    }

    .personalized-service-placeholder-tall,
    .personalized-service-placeholder-square,
    .personalized-service-placeholder-wide {
        min-height: 220px;
        aspect-ratio: auto;
    }

    .personalized-service-visual-image-tall {
        min-height: 220px;
    }

    .personalized-service-split-layout-compact:not(.is-text-only) {
        min-height: 0;
    }

    .personalized-service-paragraph-stack.is-story-grid {
        grid-template-columns: 1fr;
    }
}

@media (max-width: 768px) {
    .personalized-service-section {
        padding-top: 36px;
    }

    .personalized-service-hero-content {
        padding-top: 118px;
        padding-bottom: 60px;
        gap: 20px;
    }

    .personalized-service-block,
    .personalized-service-strengths {
        padding: 18px;
        border-radius: 18px;
    }

    .personalized-service-subsection-head {
        margin-bottom: 14px;
    }

    .personalized-service-subsection-head h3 {
        font-size: 1.35rem;
    }

    .personalized-service-placeholder-hero,
    .personalized-service-placeholder-tall,
    .personalized-service-placeholder-case,
    .personalized-service-placeholder-square,
    .personalized-service-placeholder-wide {
        min-height: 180px;
    }

    .personalized-service-visual-image-tall,
    .personalized-service-visual-image-case {
        min-height: 180px;
    }

    .personalized-service-case-panel {
        padding: 16px;
    }
}
.personalized-service-project-cta {
    display: grid;
    justify-items: center;
    text-align: center;
    gap: 16px;
    padding: 30px 32px;
    border-radius: 26px;
    border: 1px solid rgba(217, 0, 27, 0.1);
    background:
        radial-gradient(circle at 50% 0%, rgba(217, 0, 27, 0.08), transparent 42%),
        linear-gradient(180deg, rgba(255, 255, 255, 0.98) 0%, #fff7f7 100%);
    box-shadow: 0 16px 36px rgba(22, 22, 26, 0.05);
}
.personalized-service-project-kicker {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 0.78rem;
    font-weight: 700;
    letter-spacing: 0.12em;
    text-transform: uppercase;
    color: var(--accent-red);
}
.personalized-service-project-cta h2 {
    margin: 0;
    font-size: clamp(1.8rem, 3vw, 2.5rem);
    line-height: 1.15;
    color: var(--text-main);
}
.personalized-service-project-cta p {
    margin: 0;
    max-width: 760px;
    color: var(--text-light);
    line-height: 1.82;
}
.personalized-service-project-link {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 220px;
    padding: 15px 28px;
    border-radius: 999px;
    background: var(--accent-red);
    color: #ffffff;
    font-weight: 700;
    transition: transform 0.22s ease, box-shadow 0.22s ease, background 0.22s ease;
    box-shadow: 0 12px 24px rgba(217, 0, 27, 0.18);
}
.personalized-service-project-link:hover {
    background: var(--accent-red-hover);
    transform: translateY(-2px);
    box-shadow: 0 16px 28px rgba(217, 0, 27, 0.22);
}
`, "",{"version":3,"sources":["webpack://./src/styles/personalized-service.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB;;eAEW;IACX,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;AACZ;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX;;+EAE2E;IAC3E,0BAA0B;IAC1B,4CAA4C;IAC5C,0DAA0D;AAC9D;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR;;sFAEkF;AACtF;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,aAAa;IACb,4DAA4D;IAC5D,SAAS;IACT,mBAAmB;IACnB,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,wBAAwB;AAC5B;;AAEA;IACI,mBAAmB;IACnB,qCAAqC;IACrC,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,gCAAgC;IAChC,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,uBAAuB;IACvB,gBAAgB;IAChB,kBAAkB;IAClB,UAAU;AACd;;AAEA;;IAEI,qCAAqC;IACrC,wCAAwC;IACxC,mBAAmB;IACnB,8CAA8C;IAC9C,aAAa;AACjB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,SAAS;IACT,iBAAiB;IACjB,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,2CAA2C;IAC3C,SAAS;IACT,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;IACI,8CAA8C;AAClD;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,gDAAgD;IAChD,SAAS;AACb;;AAEA;;;;;IAKI,mBAAmB;IACnB,uCAAuC;IACvC,6DAA6D;AACjE;;AAEA;;;IAGI,aAAa;AACjB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;;;;IAII,kBAAkB;IAClB,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;;;;;;;IAOI,wBAAwB;IACxB,iBAAiB;AACrB;;AAEA;;IAEI,aAAa;IACb,gDAAgD;IAChD,SAAS;AACb;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,gDAAgD;IAChD,SAAS;AACb;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,aAAa;IACb,cAAc;IACd,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,aAAa;IACb,oBAAoB;IACpB,WAAW;IACX,aAAa;IACb,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;IACT,uBAAuB;IACvB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,wBAAwB;IACxB,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,wBAAwB;IACxB,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,mBAAmB;IACnB,wBAAwB;IACxB,iBAAiB;IACjB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,wBAAwB;IACxB,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,uCAAuC;IACvC,6DAA6D;IAC7D,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,0BAA0B;IAC1B,kCAAkC;IAClC,cAAc;IACd,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;;IAEI,mBAAmB;IACnB,uCAAuC;IACvC,6DAA6D;IAC7D,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,gDAAgD;IAChD,SAAS;IACT,YAAY;IACZ,sBAAsB;AAC1B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,gDAAgD;IAChD,SAAS;IACT,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,uBAAuB;IACvB,aAAa;AACjB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;IACd,iBAAiB;IACjB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;;IAEI,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,oDAAoD;AACxD;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;IACd,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,2CAA2C;IAC3C,mBAAmB;IACnB,2CAA2C;AAC/C;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI;QACI,0DAA0D;IAC9D;;IAEA;QACI,6DAA6D;IACjE;AACJ;;AAEA;IACI;;;;;;;;QAQI,0BAA0B;IAC9B;;IAEA;;QAEI,WAAW;QACX,YAAY;QACZ,qBAAqB;IACzB;;IAEA;;;QAGI,iBAAiB;QACjB,kBAAkB;IACtB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,0BAA0B;IAC9B;AACJ;;AAEA;IACI;QACI,iBAAiB;IACrB;;IAEA;QACI,kBAAkB;QAClB,oBAAoB;QACpB,SAAS;IACb;;IAEA;;QAEI,aAAa;QACb,mBAAmB;IACvB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;;;;;QAKI,iBAAiB;IACrB;;IAEA;;QAEI,iBAAiB;IACrB;;IAEA;QACI,aAAa;IACjB;AACJ;AACA;IACI,aAAa;IACb,qBAAqB;IACrB,kBAAkB;IAClB,SAAS;IACT,kBAAkB;IAClB,mBAAmB;IACnB,uCAAuC;IACvC;;2EAEuE;IACvE,8CAA8C;AAClD;AACA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,wBAAwB;AAC5B;AACA;IACI,SAAS;IACT,qCAAqC;IACrC,iBAAiB;IACjB,uBAAuB;AAC3B;AACA;IACI,SAAS;IACT,gBAAgB;IAChB,wBAAwB;IACxB,iBAAiB;AACrB;AACA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,kBAAkB;IAClB,oBAAoB;IACpB,6BAA6B;IAC7B,cAAc;IACd,gBAAgB;IAChB,8EAA8E;IAC9E,8CAA8C;AAClD;AACA;IACI,mCAAmC;IACnC,2BAA2B;IAC3B,8CAA8C;AAClD","sourcesContent":[".personalized-service-page {\r\n    background: #ffffff;\r\n}\r\n\r\n.personalized-service-section {\r\n    padding-top: 44px;\r\n    padding-bottom: 12px;\r\n}\r\n\r\n.personalized-service-page .personalized-service-section:last-of-type {\r\n    padding-bottom: 44px;\r\n}\r\n\r\n.personalized-service-hero {\r\n    position: relative;\r\n    overflow: hidden;\r\n    min-height: 60vh;\r\n    display: flex;\r\n    align-items: center;\r\n    background:\r\n        linear-gradient(135deg, rgba(10, 10, 12, 0.96), rgba(30, 12, 14, 0.92)),\r\n        #0d0d10;\r\n    color: #ffffff;\r\n}\r\n\r\n.personalized-service-hero-bg {\r\n    position: absolute;\r\n    inset: 0;\r\n}\r\n\r\n.personalized-service-grid {\r\n    position: absolute;\r\n    inset: -24%;\r\n    background-image:\r\n        linear-gradient(to right, rgba(217, 0, 27, 0.12) 1px, transparent 1px),\r\n        linear-gradient(to bottom, rgba(217, 0, 27, 0.08) 1px, transparent 1px);\r\n    background-size: 44px 44px;\r\n    transform: perspective(720px) rotateX(64deg);\r\n    animation: personalizedServiceGridMove 24s linear infinite;\r\n}\r\n\r\n.personalized-service-glow {\r\n    position: absolute;\r\n    inset: 0;\r\n    background:\r\n        radial-gradient(circle at 18% 24%, rgba(217, 0, 27, 0.2), transparent 24%),\r\n        radial-gradient(circle at 82% 72%, rgba(255, 214, 214, 0.08), transparent 22%);\r\n}\r\n\r\n.personalized-service-hero-content {\r\n    position: relative;\r\n    z-index: 1;\r\n    display: grid;\r\n    grid-template-columns: minmax(0, 1.1fr) minmax(280px, 0.7fr);\r\n    gap: 28px;\r\n    align-items: center;\r\n    padding-top: 128px;\r\n    padding-bottom: 76px;\r\n}\r\n\r\n.personalized-service-hero-copy {\r\n    max-width: 760px;\r\n}\r\n\r\n.personalized-service-kicker {\r\n    display: inline-flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    font-size: 0.78rem;\r\n    font-weight: 700;\r\n    letter-spacing: 0.12em;\r\n    text-transform: uppercase;\r\n    color: var(--accent-red);\r\n}\r\n\r\n.personalized-service-hero-title {\r\n    margin: 18px 0 14px;\r\n    font-size: clamp(2.5rem, 5vw, 4.6rem);\r\n    line-height: 1.04;\r\n}\r\n\r\n.personalized-service-hero-description {\r\n    max-width: 720px;\r\n    color: rgba(255, 255, 255, 0.84);\r\n    font-size: 1.02rem;\r\n    line-height: 1.82;\r\n}\r\n\r\n.personalized-service-hero-visual {\r\n    display: block;\r\n    justify-self: end;\r\n    width: min(100%, 360px);\r\n    min-width: 320px;\r\n    position: relative;\r\n    z-index: 1;\r\n}\r\n\r\n.personalized-service-block,\r\n.personalized-service-strengths {\r\n    background: rgba(255, 255, 255, 0.98);\r\n    border: 1px solid rgba(217, 0, 27, 0.08);\r\n    border-radius: 24px;\r\n    box-shadow: 0 14px 32px rgba(22, 22, 26, 0.05);\r\n    padding: 24px;\r\n}\r\n\r\n.personalized-service-block + .personalized-service-block {\r\n    margin-top: 16px;\r\n}\r\n\r\n.personalized-service-subsection-head {\r\n    margin-bottom: 16px;\r\n    display: block;\r\n    align-items: center;\r\n}\r\n\r\n.personalized-service-subsection-head h3 {\r\n    margin: 0;\r\n    font-size: 1.6rem;\r\n    line-height: 1.15;\r\n    color: #343434;\r\n}\r\n\r\n.personalized-service-split-layout {\r\n    display: grid;\r\n    grid-template-columns: minmax(0, 1fr) 220px;\r\n    gap: 18px;\r\n    align-items: stretch;\r\n    grid-auto-rows: 1fr;\r\n}\r\n\r\n.personalized-service-split-layout-compact {\r\n    grid-template-columns: minmax(0, 0.94fr) 380px;\r\n}\r\n\r\n.personalized-service-split-layout-compact:not(.is-text-only) {\r\n    min-height: 340px;\r\n}\r\n\r\n.personalized-service-split-layout.is-text-only {\r\n    grid-template-columns: 1fr;\r\n}\r\n\r\n.personalized-service-process-grid {\r\n    display: grid;\r\n    grid-template-columns: repeat(2, minmax(0, 1fr));\r\n    gap: 14px;\r\n}\r\n\r\n.personalized-service-process-card,\r\n.personalized-service-advantage-card,\r\n.personalized-service-point-card,\r\n.personalized-service-strength-card,\r\n.personalized-service-case-card {\r\n    border-radius: 18px;\r\n    border: 1px solid rgba(217, 0, 27, 0.1);\r\n    background: linear-gradient(180deg, #ffffff 0%, #fdf8f7 100%);\r\n}\r\n\r\n.personalized-service-process-card,\r\n.personalized-service-point-card,\r\n.personalized-service-strength-card {\r\n    padding: 18px;\r\n}\r\n\r\n.personalized-service-process-card.is-wide {\r\n    grid-column: 1 / -1;\r\n}\r\n\r\n.personalized-service-process-card h4,\r\n.personalized-service-advantage-card h4,\r\n.personalized-service-point-card h4,\r\n.personalized-service-strength-card h3 {\r\n    margin-bottom: 6px;\r\n    color: var(--text-main);\r\n    line-height: 1.5;\r\n}\r\n\r\n.personalized-service-process-card p,\r\n.personalized-service-advantage-card p,\r\n.personalized-service-point-card p,\r\n.personalized-service-paragraph-stack p,\r\n.personalized-service-strength-card p,\r\n.personalized-service-strength-intro,\r\n.personalized-service-lead {\r\n    color: var(--text-light);\r\n    line-height: 1.82;\r\n}\r\n\r\n.personalized-service-advantage-grid,\r\n.personalized-service-strength-grid {\r\n    display: grid;\r\n    grid-template-columns: repeat(2, minmax(0, 1fr));\r\n    gap: 14px;\r\n}\r\n\r\n.personalized-service-advantage-card {\r\n    padding: 18px;\r\n}\r\n\r\n.personalized-service-case-grid {\r\n    display: grid;\r\n    grid-template-columns: repeat(2, minmax(0, 1fr));\r\n    gap: 14px;\r\n}\r\n\r\n.personalized-service-case-grid.is-single {\r\n    grid-template-columns: minmax(0, 420px);\r\n}\r\n\r\n.personalized-service-case-card {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 12px;\r\n    padding: 14px;\r\n    flex: 1 1 auto;\r\n    height: 100%;\r\n    min-width: 0;\r\n}\r\n\r\n.personalized-service-case-image {\r\n    overflow: hidden;\r\n    border-radius: 14px;\r\n    display: flex;\r\n    align-items: stretch;\r\n    flex: 1 1 0;\r\n    min-height: 0;\r\n    height: 100%;\r\n    background: #f4f4f4;\r\n}\r\n\r\n.personalized-service-case-placeholder {\r\n    width: 100%;\r\n    height: 100%;\r\n    min-height: 0;\r\n    border-radius: 14px;\r\n    background: #d9d9d9;\r\n}\r\n\r\n.personalized-service-case-copy {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    gap: 14px;\r\n    color: var(--text-main);\r\n    font-weight: 700;\r\n    line-height: 1.7;\r\n}\r\n\r\n.personalized-service-case-arrow {\r\n    color: var(--accent-red);\r\n    font-size: 1.2rem;\r\n    flex-shrink: 0;\r\n}\r\n\r\n.personalized-service-custom-stack {\r\n    display: grid;\r\n    gap: 16px;\r\n}\r\n\r\n.personalized-service-item-case {\r\n    margin-top: 18px;\r\n}\r\n\r\n.personalized-service-content-column {\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: stretch;\r\n    height: 100%;\r\n    min-height: 0;\r\n}\r\n\r\n.personalized-service-content-column.is-story {\r\n    gap: 14px;\r\n}\r\n\r\n.personalized-service-case-section-title {\r\n    margin-bottom: 14px;\r\n    color: var(--accent-red);\r\n    font-size: 0.9rem;\r\n    font-weight: 700;\r\n    letter-spacing: 0.08em;\r\n    text-transform: uppercase;\r\n}\r\n\r\n.personalized-service-case-panel {\r\n    width: 100%;\r\n    height: 100%;\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: stretch;\r\n    flex: 1 1 auto;\r\n    padding: 18px;\r\n    border-radius: 18px;\r\n    border: 1px solid rgba(217, 0, 27, 0.1);\r\n    background: linear-gradient(180deg, #ffffff 0%, #fdf8f7 100%);\r\n    min-height: 0;\r\n}\r\n\r\n.personalized-service-case-grid-side {\r\n    display: grid;\r\n    grid-template-columns: 1fr;\r\n    grid-template-rows: minmax(0, 1fr);\r\n    flex: 1 1 auto;\r\n    height: 100%;\r\n    min-height: 0;\r\n}\r\n\r\n.personalized-service-case-grid-side.is-single {\r\n    grid-template-columns: 1fr;\r\n}\r\n\r\n.personalized-service-lead {\r\n    margin-bottom: 12px;\r\n    font-size: 0.98rem;\r\n    font-weight: 700;\r\n    color: var(--text-main);\r\n}\r\n\r\n.personalized-service-story-intro,\r\n.personalized-service-story-card {\r\n    border-radius: 18px;\r\n    border: 1px solid rgba(217, 0, 27, 0.1);\r\n    background: linear-gradient(180deg, #ffffff 0%, #fdf8f7 100%);\r\n    padding: 18px;\r\n}\r\n\r\n.personalized-service-story-intro .personalized-service-lead {\r\n    margin-bottom: 0;\r\n    font-size: 1rem;\r\n    line-height: 1.78;\r\n}\r\n\r\n.personalized-service-point-grid {\r\n    display: grid;\r\n    grid-template-columns: repeat(2, minmax(0, 1fr));\r\n    gap: 14px;\r\n    height: 100%;\r\n    align-content: stretch;\r\n}\r\n\r\n.personalized-service-point-grid > .personalized-service-point-card {\r\n    height: 100%;\r\n}\r\n\r\n.personalized-service-paragraph-stack {\r\n    display: grid;\r\n    gap: 10px;\r\n}\r\n\r\n.personalized-service-paragraph-stack.is-story-grid {\r\n    grid-template-columns: repeat(2, minmax(0, 1fr));\r\n    gap: 14px;\r\n    flex: 1 1 auto;\r\n}\r\n\r\n.personalized-service-story-card {\r\n    display: flex;\r\n    align-items: flex-start;\r\n    min-height: 100%;\r\n}\r\n\r\n.personalized-service-story-card p {\r\n    margin: 0;\r\n}\r\n\r\n.personalized-service-strengths {\r\n    display: grid;\r\n    gap: 18px;\r\n}\r\n\r\n.personalized-service-strength-intro {\r\n    max-width: 900px;\r\n    font-size: 0.98rem;\r\n}\r\n\r\n.personalized-service-side-visual {\r\n    width: 100%;\r\n    height: 100%;\r\n    display: flex;\r\n    align-self: stretch;\r\n    min-height: 0;\r\n}\r\n\r\n.personalized-service-side-visual-case {\r\n    height: 100%;\r\n    min-height: 0;\r\n}\r\n\r\n.personalized-service-side-visual-case .personalized-service-case-card {\r\n    padding: 0;\r\n    border: none;\r\n    background: transparent;\r\n    min-height: 0;\r\n}\r\n\r\n.personalized-service-side-visual-case .personalized-service-case-copy {\r\n    padding-top: 4px;\r\n}\r\n\r\n.personalized-service-side-visual-case .personalized-service-case-image {\r\n    min-height: 240px;\r\n}\r\n\r\n.personalized-service-visual-image {\r\n    width: 100%;\r\n    height: 100%;\r\n    display: block;\r\n    object-fit: cover;\r\n    object-position: center;\r\n    border-radius: 18px;\r\n}\r\n\r\n.personalized-service-visual-image-tall {\r\n    min-height: 100%;\r\n}\r\n\r\n.personalized-service-visual-image-case {\r\n    min-height: 0;\r\n    border-radius: 14px;\r\n}\r\n\r\n.personalized-service-case-copy span:first-child,\r\n.personalized-service-case-section-title {\r\n    white-space: nowrap;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n}\r\n\r\n.personalized-service-case-copy span:first-child {\r\n    flex: 1 1 auto;\r\n    min-width: 0;\r\n    font-size: clamp(0.86rem, 0.74rem + 0.25vw, 0.98rem);\r\n}\r\n\r\n.personalized-service-placeholder {\r\n    width: 100%;\r\n    height: 100%;\r\n    display: block;\r\n    background: #d1d5db;\r\n    border-radius: 18px;\r\n}\r\n\r\n.personalized-service-placeholder-hero {\r\n    min-height: 260px;\r\n    border: 1px solid rgba(255, 255, 255, 0.14);\r\n    background: #d1d5db;\r\n    box-shadow: 0 18px 40px rgba(0, 0, 0, 0.18);\r\n}\r\n\r\n.personalized-service-placeholder-tall {\r\n    min-height: 100%;\r\n}\r\n\r\n.personalized-service-placeholder-case {\r\n    min-height: 160px;\r\n}\r\n\r\n.personalized-service-placeholder-square {\r\n    aspect-ratio: 1 / 1;\r\n}\r\n\r\n.personalized-service-placeholder-wide {\r\n    min-height: 160px;\r\n}\r\n\r\n@keyframes personalizedServiceGridMove {\r\n    from {\r\n        transform: perspective(720px) rotateX(64deg) translateY(0);\r\n    }\r\n\r\n    to {\r\n        transform: perspective(720px) rotateX(64deg) translateY(44px);\r\n    }\r\n}\r\n\r\n@media (max-width: 992px) {\r\n    .personalized-service-hero-content,\r\n    .personalized-service-split-layout,\r\n    .personalized-service-split-layout-compact,\r\n    .personalized-service-process-grid,\r\n    .personalized-service-advantage-grid,\r\n    .personalized-service-case-grid,\r\n    .personalized-service-point-grid,\r\n    .personalized-service-strength-grid {\r\n        grid-template-columns: 1fr;\r\n    }\r\n\r\n    .personalized-service-hero-visual,\r\n    .personalized-service-side-visual {\r\n        width: 100%;\r\n        min-width: 0;\r\n        justify-self: stretch;\r\n    }\r\n\r\n    .personalized-service-placeholder-tall,\r\n    .personalized-service-placeholder-square,\r\n    .personalized-service-placeholder-wide {\r\n        min-height: 220px;\r\n        aspect-ratio: auto;\r\n    }\r\n\r\n    .personalized-service-visual-image-tall {\r\n        min-height: 220px;\r\n    }\r\n\r\n    .personalized-service-split-layout-compact:not(.is-text-only) {\r\n        min-height: 0;\r\n    }\r\n\r\n    .personalized-service-paragraph-stack.is-story-grid {\r\n        grid-template-columns: 1fr;\r\n    }\r\n}\r\n\r\n@media (max-width: 768px) {\r\n    .personalized-service-section {\r\n        padding-top: 36px;\r\n    }\r\n\r\n    .personalized-service-hero-content {\r\n        padding-top: 118px;\r\n        padding-bottom: 60px;\r\n        gap: 20px;\r\n    }\r\n\r\n    .personalized-service-block,\r\n    .personalized-service-strengths {\r\n        padding: 18px;\r\n        border-radius: 18px;\r\n    }\r\n\r\n    .personalized-service-subsection-head {\r\n        margin-bottom: 14px;\r\n    }\r\n\r\n    .personalized-service-subsection-head h3 {\r\n        font-size: 1.35rem;\r\n    }\r\n\r\n    .personalized-service-placeholder-hero,\r\n    .personalized-service-placeholder-tall,\r\n    .personalized-service-placeholder-case,\r\n    .personalized-service-placeholder-square,\r\n    .personalized-service-placeholder-wide {\r\n        min-height: 180px;\r\n    }\r\n\r\n    .personalized-service-visual-image-tall,\r\n    .personalized-service-visual-image-case {\r\n        min-height: 180px;\r\n    }\r\n\r\n    .personalized-service-case-panel {\r\n        padding: 16px;\r\n    }\r\n}\r\n.personalized-service-project-cta {\r\n    display: grid;\r\n    justify-items: center;\r\n    text-align: center;\r\n    gap: 16px;\r\n    padding: 30px 32px;\r\n    border-radius: 26px;\r\n    border: 1px solid rgba(217, 0, 27, 0.1);\r\n    background:\r\n        radial-gradient(circle at 50% 0%, rgba(217, 0, 27, 0.08), transparent 42%),\r\n        linear-gradient(180deg, rgba(255, 255, 255, 0.98) 0%, #fff7f7 100%);\r\n    box-shadow: 0 16px 36px rgba(22, 22, 26, 0.05);\r\n}\r\n.personalized-service-project-kicker {\r\n    display: inline-flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    font-size: 0.78rem;\r\n    font-weight: 700;\r\n    letter-spacing: 0.12em;\r\n    text-transform: uppercase;\r\n    color: var(--accent-red);\r\n}\r\n.personalized-service-project-cta h2 {\r\n    margin: 0;\r\n    font-size: clamp(1.8rem, 3vw, 2.5rem);\r\n    line-height: 1.15;\r\n    color: var(--text-main);\r\n}\r\n.personalized-service-project-cta p {\r\n    margin: 0;\r\n    max-width: 760px;\r\n    color: var(--text-light);\r\n    line-height: 1.82;\r\n}\r\n.personalized-service-project-link {\r\n    display: inline-flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    min-width: 220px;\r\n    padding: 15px 28px;\r\n    border-radius: 999px;\r\n    background: var(--accent-red);\r\n    color: #ffffff;\r\n    font-weight: 700;\r\n    transition: transform 0.22s ease, box-shadow 0.22s ease, background 0.22s ease;\r\n    box-shadow: 0 12px 24px rgba(217, 0, 27, 0.18);\r\n}\r\n.personalized-service-project-link:hover {\r\n    background: var(--accent-red-hover);\r\n    transform: translateY(-2px);\r\n    box-shadow: 0 16px 28px rgba(217, 0, 27, 0.22);\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
